import { getFileExtension } from './mediaFormats';

const FFMPEG_CORE_BASE_URL = 'https://whisper-cpp-models.s3.eu-west-3.amazonaws.com';

export function parseDurationFromFFmpegLog(messages) {
  for (const message of messages) {
    const match = String(message).match(/Duration:\s*(\d+):(\d{2}):(\d{2}(?:\.\d+)?)/i);
    if (!match) continue;
    const [, hours, minutes, seconds] = match;
    const duration = (Number(hours) * 3600) + (Number(minutes) * 60) + Number(seconds);
    if (Number.isFinite(duration) && duration > 0) return duration;
  }
  return null;
}

export async function probeMediaDuration(file) {
  const extension = getFileExtension(file);
  if (extension === 'unknown') throw new Error('Unsupported audio format.');

  const [{ FFmpeg }, { fetchFile, toBlobURL }] = await Promise.all([
    import('@ffmpeg/ffmpeg'),
    import('@ffmpeg/util'),
  ]);
  const ffmpeg = new FFmpeg();
  const input = `probe-input.${extension}`;
  const messages = [];
  const handleLog = ({ message }) => messages.push(message);
  ffmpeg.on('log', handleLog);

  try {
    await ffmpeg.load({
      coreURL: await toBlobURL(`${FFMPEG_CORE_BASE_URL}/ffmpeg-core.js`, 'text/javascript'),
      wasmURL: await toBlobURL(`${FFMPEG_CORE_BASE_URL}/ffmpeg-core.wasm`, 'application/wasm'),
    });
    await ffmpeg.writeFile(input, await fetchFile(file));
    await ffmpeg.exec(['-i', input]);

    const duration = parseDurationFromFFmpegLog(messages);
    if (!duration) throw new Error('No s’ha pogut llegir la durada del fitxer multimèdia.');
    return duration;
  } finally {
    await ffmpeg.deleteFile(input).catch(() => undefined);
    ffmpeg.off('log', handleLog);
    ffmpeg.terminate();
  }
}
